'use client';

import React from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { STEPS } from './constants';
import styles from './styles.module.css';

import { Container } from '@/components/Container';
import { type SupportedLocation } from '@/modules/location/constants';

type Props = {
  location: SupportedLocation;
};

export function HowDepopShippingWorks({ location }: Props) {
  const t = useTranslations('shipping');

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.header}>
          <Heading variant="xl" as="h2">
            {t('ShippingPage.HowItWorks.Title')}
          </Heading>
          <Body variant="md-regular">
            {t('ShippingPage.HowItWorks.Subtitle')}
          </Body>
        </div>
        <ol className={styles.stepsList}>
          {STEPS.map((step) => {
            const Illustration =
              step.illustration[location] ?? step.illustration.default;

            return (
              <li key={step.titleKey} className={styles.stepItem}>
                <div className={styles.stepCard}>
                  <div className={styles.stepIconWrapper}>
                    <Illustration size="regular" />
                  </div>
                  <div className={styles.stepContent}>
                    <Heading variant="md" as="h3">
                      {t(step.titleKey)}
                    </Heading>
                    <Body variant="md-regular">{t(step.descriptionKey)}</Body>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </Container>
    </section>
  );
}
